import { ChangeDetectionStrategy, Component, computed, Signal } from '@angular/core';
import { ProductContentModel } from '@libs/cms/models';
import { AddToShoppingListDialogComponent, ProductCardComponent, ProductSliderComponent } from '@libs/shop/components';
import { ProductModel } from '@libs/shop/models';
import { ProductImpressionDirective } from '@libs/shared/tracking';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-product-content',
  imports: [ProductSliderComponent, AddToShoppingListDialogComponent, ProductCardComponent, ProductImpressionDirective],
  templateUrl: './product-content.component.html',
  styleUrl: './product-content.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductContentComponent extends ContentBaseComponent<ProductContentModel> {
  public readonly trackingLocation: string = 'cepAppProductContent';

  public cardViewClass: Signal<string> = computed(() => {
    return this.data().cardView + '-view';
  });

  public products: Signal<ProductModel[]> = computed(() => {
    return (this.data().remoteData as ProductModel[]).map((product: ProductModel) => {
      return {
        ...product,
        actionType: product.bundleType === 'closed' ? 'show-product' : 'add-to-cart',
      };
    });
  });

  public highlightedProducts: Signal<ProductModel[]> = computed(() => {
    const highlightedSkus: string[] = this.data().highlightedProducts;

    return this.products().filter(x => highlightedSkus.includes(x.sku));
  });
}
